import { Text } from 'ui/components/primitives';

import Styles from './Combo.components.styles';
import { QuantitySelector } from '../../QuantitySelector';

import type { ComboButtonProps } from './Combo.components';

export const Button = ({
  available,
  code,
  isComplete,
  isDisabled,
  max,
  onChangeItem,
  quantity,
  structureCode,
}: ComboButtonProps) => {
  const handleChangeItem = (amount: number) => {
    onChangeItem({
      quantity: amount,
      sku: code,
      structureCode,
    });
  };

  const handleAddFirstItem = () => {
    onChangeItem({
      quantity: 1,
      sku: code,
      structureCode,
    });
  };

  if (quantity > 0) {
    return (
      <Styles.QuantityWrapper>
        <QuantitySelector
          max={isComplete ? quantity : max}
          onChange={handleChangeItem}
          size="small"
          value={quantity}
        />
      </Styles.QuantityWrapper>
    );
  }

  if (available) {
    return (
      <Styles.ActionButton
        disabled={isDisabled || isComplete}
        onClick={handleAddFirstItem}
        size="small"
        stretch
      >
        <Text textAlign="center" variant="body-medium-short">
          Selecionar
        </Text>
      </Styles.ActionButton>
    );
  }

  return (
    <Styles.ActionButton disabled size="small" stretch>
      <Text textAlign="center" variant="body-medium-short">
        Sem estoque
      </Text>
    </Styles.ActionButton>
  );
};
